const Overflow = () => {
    return <div className="container fluid py-2" id="overflow">

        <div className="container fluid">
            <p className="text xl"><a href="#overflow" className="link">&#128279;</a> Overflow</p>
            <p className="text md">
                Overflow used to define the <code>overflow</code> property, in case is needed.
    </p>
        </div>

        <div className="spacer md"></div>

        <div className="container lg">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <code>.overflow-hidden</code>
                            </td>
                            <td>Sets the CSS property to: <code>overflow:hidden!important;</code></td>
                        </tr>
                        <tr>
                            <td>
                                <code>.overflow-y-hidden</code>
                            </td>
                            <td>Sets the CSS property to: <code>overflow-y:hidden!important;</code></td>
                        </tr>
                        <tr>
                            <td>
                                <code>.overflow-x-hidden</code>
                            </td>
                            <td>Sets the CSS property to: <code>overflow-x:hidden!important;</code></td>
                        </tr>
                        <tr>
                            <td>
                                <code>.overflow-scroll</code>
                            </td>
                            <td>Sets the CSS property to: <code>overflow:scroll!important;</code></td>
                        </tr>
                        <tr>
                            <td>
                                <code>.overflow-y-scroll</code>
                            </td>
                            <td>Sets the CSS property to: <code>overflow-y:scroll!important;</code></td>
                        </tr>
                        <tr>
                            <td>
                                <code>.overflow-x-scroll</code>
                            </td>
                            <td>Sets the CSS property to: <code>overflow-x:scroll!important;</code></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
}

export default Overflow